import RlsApp from './RlsApp.vue'
import RlsForm from './pages/RlsForm.vue'
import RlsOperation from './pages/RlsOperation.vue'
import RlsMaster from './pages/RlsMaster.vue'

export default {
  path: '/Rls',
  component: RlsApp,
  children: [
    {
      path: '/RlsForm',
      name: 'RlsForm',
      component: RlsForm,
      meta: { requiresAuth: true, title: 'apollo-RP - RLS' },
      props: true
    },
    {
      path: '/RlsOperation',
      name: 'RlsOperation',
      component: RlsOperation,
      meta: { requiresAuth: true, title: 'apollo-RP - 稼働' },
      props: true
    },
    {
      path: '/RlsMaster',
      name: 'RlsMaster',
      component: RlsMaster,
      meta: { requiresAuth: true, title: 'apollo-RP - RLSマスタ' },
      props: true
    },
  ]
}
